import { ensure, playerSchema, type Player } from "./model";

export function parseCsv(text: string): string[][] {
  ensure(text.length <= 500000, "CSV files must be smaller than 500 KB.");
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = "";
  let quoted = false;
  const input = text.replace(/^\uFEFF/, "");
  for (let i = 0; i < input.length; i++) {
    const char = input[i];
    if (char === '"') {
      if (quoted && input[i + 1] === '"') {
        cell += '"';
        i++;
      } else quoted = !quoted;
    } else if (char === "," && !quoted) {
      row.push(cell.trim());
      cell = "";
    } else if (char === "\n" && !quoted) {
      row.push(cell.trim());
      if (row.some(Boolean)) rows.push(row);
      row = [];
      cell = "";
    } else if (char !== "\r" || quoted) cell += char;
  }
  ensure(!quoted, "A CSV quote was not closed.");
  row.push(cell.trim());
  if (row.some(Boolean)) rows.push(row);
  return rows;
}
export function importPlayers(text: string): Player[] {
  const [header, ...rows] = parseCsv(text);
  ensure(header?.join(",") === "id,name", "The CSV header must be: id,name");
  ensure(
    rows.length > 0 && rows.length <= 5000,
    "Import between one and 5,000 players.",
  );
  const players = rows.map((row, i) => {
    ensure(row.length === 2, `Row ${i + 2} needs an ID and display name.`);
    const parsed = playerSchema.safeParse({
      id: row[0],
      name: row[1],
      points: 0,
    });
    ensure(parsed.success, `Check the ID and name on row ${i + 2}.`);
    return parsed.data;
  });
  ensure(
    new Set(players.map((p) => p.id)).size === players.length,
    "Player IDs must be unique within the import.",
  );
  return players;
}
export function exportCsv(rows: Array<Array<string | number>>): string {
  return rows
    .map((row) =>
      row
        .map((value) => {
          let text = String(value);
          if (typeof value === "string" && /^[=+\-@\t\r]/.test(text))
            text = `'${text}`;
          return `"${text.replaceAll('"', '""')}"`;
        })
        .join(","),
    )
    .join("\r\n");
}
